import { render, staticRenderFns } from "./DeleteState.vue?vue&type=template&id=2fc7fb24&scoped=true&lang=pug&"
import script from "./DeleteState.vue?vue&type=script&lang=js&"
export * from "./DeleteState.vue?vue&type=script&lang=js&"
import style0 from "./DeleteState.vue?vue&type=style&index=0&id=2fc7fb24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc7fb24",
  null
  
)

export default component.exports